import * as React from "react";
import { action, observable, computed } from "mobx";
import { observer, Provider } from "mobx-react";
import { Screenfull } from "../Screenfull";


export interface IFullScreenProperties {
	backgroundColor?: string;
}

@observer
export class FullScreen extends React.Component<IFullScreenProperties, {}> {

	private mainElement: HTMLElement;

	@action toggleFullScreen = (): boolean => {
		return Screenfull.toggle(this.mainElement);
	}

	render() {
		let mainStyle: React.CSSProperties = { width: "100%", height: "100%" };
		if (this.props.backgroundColor) {
			mainStyle.backgroundColor = this.props.backgroundColor;
		}
		return <Provider fullScreen={this}>
			<div ref={(elem) => { this.mainElement = elem; }} style={mainStyle}>
				{this.props.children}
			</div>
		</Provider>;
	}

}